import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { Box, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ReactComponent as MonitorIcon } from "assets/images/icons/btn_monitor.svg";
import { ReactComponent as PlaybackIconLight } from "assets/images/icons/btn_report_light.svg";
import CameraSearchPanel from "../../Liveview/components/ResourceSidebar/CameraSearchPanel";

const PlaybackSidebar = ({
  devices,
  nvrs,
  onPlayCamera,
  onPlayCameras,
  onToggleFavorite,
}) => {
  const navigate = useNavigate();
  const theme = useTheme();

  const toggleBtnBase = {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
    py: 1,
    fontSize: 14,
    fontWeight: 600,
    borderRadius: 0,
    textTransform: "none",
    minWidth: 0,
  };

  return (
    <Box
      className="playback-player"
      sx={{
        backgroundColor: theme.palette.primary.white,
        borderRight: "1px solid rgba(0,0,0,0.1)",
        borderRadius: `${theme.shape.customBorderRadius[4]} 0 0 ${theme.shape.customBorderRadius[4]}`,
        width: 300,
        minWidth: 270,
        display: "flex",
        flexDirection: "column",
        boxShadow: "1px 1px 4px 0 rgba(0,0,0,0.2)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          m: "16px 12px",
          border: `1.5px solid ${theme.palette.primary.main}`,
          borderRadius: theme.shape.customBorderRadius[1],
          overflow: "hidden",
        }}
      >
        <Button
          disableRipple
          onClick={() => navigate("/surveillance/liveview")}
          sx={{
            ...toggleBtnBase,
            backgroundColor: "transparent",
            color: theme.palette.primary.main,
            "&:hover": { backgroundColor: "rgba(23,38,100,0.06)" },
          }}
        >
          <MonitorIcon width={28} height={28} />
          <FormattedMessage id="liveview" />
        </Button>
        <Button
          disableRipple
          sx={{
            ...toggleBtnBase,
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.white,
            "&:hover": { backgroundColor: theme.palette.primary.main },
          }}
        >
          <PlaybackIconLight width={28} height={28} />
          <FormattedMessage id="playback" />
        </Button>
      </Box>

      {/* Scrollable content */}
      <Box sx={{ flex: 1, overflowY: "auto", pb: "12px" }}>
        <CameraSearchPanel
          devices={devices}
          nvrs={nvrs}
          showSectionPlay={false}
          onPlayCamera={onPlayCamera}
          onPlayCameras={onPlayCameras}
          onToggleFavorite={onToggleFavorite}
        />
      </Box>
    </Box>
  );
};

PlaybackSidebar.propTypes = {
  devices: PropTypes.array.isRequired,
  nvrs: PropTypes.array.isRequired,
  onPlayCamera: PropTypes.func.isRequired,
  onPlayCameras: PropTypes.func.isRequired,
  onToggleFavorite: PropTypes.func.isRequired,
};

export default PlaybackSidebar;
